package one.healthium.cali.presentation.feature.today.components

import androidx.compose.foundation.Image
import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.IntrinsicSize
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.width
import androidx.compose.material3.Surface
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.unit.dp
import ifaandroid.apps.cali.composeapp.generated.resources.Res
import ifaandroid.apps.cali.composeapp.generated.resources.img_meal_plan
import one.healthium.cali.paytone_16
import one.healthium.loco.resolve
import one.healthium.meal_plans.domain.MealPlanInfoModel
import one.healthium.ui.compose.theme.AppTheme
import org.jetbrains.compose.resources.painterResource

@Composable
fun MealPlanCard(
    modifier: Modifier = Modifier,
    mealPlan: MealPlanInfoModel?,
    onClick: (MealPlanInfoModel) -> Unit,
) {
    Surface(
        modifier = modifier.width(IntrinsicSize.Min),
        shape = AppTheme.shapes.small,
        onClick = {
            mealPlan?.let { onClick(it) }
        }
    ) {
        Image(
            painter = painterResource(Res.drawable.img_meal_plan),
            contentDescription = null,
        )
        Column(
            modifier = Modifier
                .background(Color(0x2E286B59))
                .fillMaxSize()
                .padding(horizontal = 12.dp, vertical = 16.dp),
        ) {
            Text(
                text = mealPlan?.name?.resolve() ?: "",
                style = AppTheme.textStyles.paytone_16,
                color = AppTheme.colors.textInverted100,
            )
        }
    }
}